export default __webpack_public_path__ + "static/cafe_36011-5b0a736710c9026daa57b89a8ce4a97d.png";